/* JWT / JWK */
export const ERROR_FAILED_FETCH_PUBLIC_KEY = "Failed to fetch public key.";
export const JWT_HASHING_ALGORITHM = "SHA-256";
export const RSA_ALGORITHM = "RSASSA-PKCS1-v1_5";
/* Analytics Tracking */
export const DATA_LAYER_ERROR_EVENT = "errorDL";
export const DATA_LAYER_VIEW_ITEM_LIST_EVENT = "view_item_list";
export const DATA_LAYER_EEC_PRODUCT_IMPRESSION_EVENT = "eec-productImpressions";
export const DATA_LAYER_PRODUCT_SELECT_ITEM = "select_item";
export const DATA_LAYER_PRODUCT_CLICK = "eec-productClick";
export const DATA_LAYER_HOTEL_DETAILS_CLICK = "promoTiles";
export const DATA_LAYER_PROMO_SORT_BY = "promoSorting";
/* sorting */
export const DEFAULT_SORT_ID = "price";
export const DEFAULT_SORT_ORDER = "asc";
